import { Promise } from 'rsvp';
import { inject as service } from '@ember/service';
import Mixin from '@ember/object/mixin';
import { closeModal, showModal } from 'sh-www/utils/modal-controls';
import {
  LSG_MODAL_TEXT_EDITOR__HEIGHT_STYLE
} from 'sh-www/components/modals/lsg/lsg-modal-text-editor';

export default Mixin.create({
  /**
   * Register services
   */
  assignmentCommandService : service('commands/assignment-commands'),

  /**
   * Show the decline other applications modal and update.
   *
   * @param {Assignment} assignment
   * @param {User} seller
   * @param {String[]=} opt_includes
   * @return {Ember.RSVP.Promise}     Resolves true when user successfully confirms the decline other apps.
   */
  showDeclineOtherApplicationsModal(assignment, seller, opt_includes = []) {
    return new Promise((resolve, reject) => {
      let modalModel = {
        heightStyle: LSG_MODAL_TEXT_EDITOR__HEIGHT_STYLE.NO_MAX_HEIGHT,
        title: `Decline other applications?`,
        subtitle: `Once ${seller.get('firstName')} accepts your offer, you can automatically decline all other pending applications.`,
        textAreaPlaceholder: `Optional: Leave a note`,
        secondaryMessage: `This decline message will only be send once ${seller.get('firstName')} accepts the offer and this project becomes active.`,
        cancelText: 'Skip',
        confirmText: 'Decline others',
        onCancelMessage: () => {
          resolve(true);
          closeModal(this);
        },
        onConfirmMessage: (message) => {
          let updateProps = {
            'auto_decline': '1',
          };

          if (message) {
            updateProps['auto_decline_message'] = message;
          }

          this.get('assignmentCommandService').updateAssignment(
            assignment,
            updateProps,
            opt_includes
          ).then(() => {
            resolve(message);
          }).catch(e => {
            reject(e);
          });
        }
      };

      showModal(this, 'lsg/lsg-modal-text-editor', modalModel);
    });
  }
});
